import {IMenuCategory} from '../interfaces/IMenuCategory';

export const getCategoryAnchor = (category: IMenuCategory): string =>
    `menu-category-${encodeURIComponent(category.id ?? category.name ?? '')}`;

export const orderMenuCategories = (categories: IMenuCategory[]): IMenuCategory[] => [
    ...categories.filter(category => category.name?.toLowerCase() !== 'alcohol'),
    ...categories.filter(category => category.name?.toLowerCase() === 'alcohol')
];
